import { throwApiError } from "../components/lms-shared/store/error-handling-actions";
import { ParticipantTypeEnumText } from "../models/ParticipantTypeEnum";
import { studyGroupsApi } from "../utils";
import { curriculumAction } from "./curriculum-slice"

export const fetchCurriculumData = (MessageCB) => {

  return async (dispatch, getState) => {
    try {
      const state = getState();
      const texts = state.translate.texts;

      studyGroupsApi.studyGroupsFilterRangePost({ studyGroupsRangeFilter: { applicationId: state.application.applicationId, includeSelfRegister: true, participantType: ParticipantTypeEnumText.student } }, async (error, resdata, response) => {
        if (error) {
          dispatch(throwApiError({ userMessage: texts.studyGroupsFilterError, error: error, statusCode: response?.statusCode, message: "studyGroupsFilterRangePost " + error.message, level: 2, component: "curriculum-actions", line: 17 }))
        }
        else {
          resdata = resdata?.map(sg => {
            let newObj = { ...sg };
            if (sg?.course?.additionalData)
              try {
                newObj.course.additionalData = JSON.parse(sg.course.additionalData)
              }
              catch {

              }
            return newObj
          });
          dispatch(curriculumAction.init(resdata));
        }
      })
    }
    catch (e) {
      console.error(e);
    }
  }
}
